// extracted by mini-css-extract-plugin
module.exports = {"button":"GlobalSearch_button__CLGjj","content":"GlobalSearch_content__1BBDW"};